import infographic from "./infographic.png";
import article from "./article.png";
import photo from "./photo.png";
import uiux from "./uiux.png";
import video from "./video.png";

let datas = [
  {
    id: 1,
    title: "Infographic Competition",
    image: infographic,
    category: "SMA/Sederajat",
    tema: "AI dalam Lensa Jurnalistik / AI Dibalik Kehidupan Manusia",
    list: [
      "Lomba bersifat individu dan setiap peserta hanya diperbolehkan mengirim maksimal 1 karya infografis",
      "Setiap peserta hanya boleh mengikuti 1 jenis lomba",
      "Karya yang dikirimkan merupakan hasil karya orisinil peserta dan belum pernah dipublikasikan ataupun diperlombakan",
      "Peserta wajib mengisi surat pernyataan keaslian karya dan menyerahkannya saat pengumpulan hasil karya",
      "Karya yang dikirimkan tidak mengandung unsur pornografi, SARA, plagiarisme, hoax, atau hal merugikan lainnya",
    ],
  },
  {
    id: 2,
    title: "Feature Article Competition",
    image: article,
    category: "Mahasiswa",
    tema: "Bagaimana AI Mengubah Dunia Jurnalistik ( How AI Change Journalism )",
    list: [
      "Lomba bersifat individu dan setiap peserta hanya diperbolehkan mengirim maksimal 1 karya artikel",
      "Setiap peserta hanya boleh mengikuti 1 jenis lomba",
      "Karya yang dikirimkan merupakan hasil karya orisinil peserta dan belum pernah dipublikasikan ataupun diperlombakan",
      "Peserta wajib mengisi surat pernyataan keaslian karya dan menyerahkannya saat pengumpulan hasil karya",
      "Karya yang dikirimkan tidak mengandung unsur pornografi, SARA, plagiarisme, hoax, atau hal merugikan lainnya",
    ],
  },
  {
    id: 3,
    title: "UI/UX Design Competition",
    image: uiux,
    category: "Mahasiswa",
    tema: "Mengembangkan Inovasi Website dalam Mempersiapkan Jurnalisme di Era 5.0",
    list: [
      "Lomba bersifat individu dan setiap peserta hanya diperbolehkan mengirim maksimal 1 karya UI/UX Web Desain",
      "Setiap peserta hanya boleh mengikuti 1 jenis lomba",
      "Karya yang dikirimkan merupakan hasil karya orisinil peserta dan belum pernah dipublikasikan ataupun diperlombakan",
      "Peserta wajib mengisi surat pernyataan keaslian karya dan menyerahkannya saat pengumpulan hasil karya",
      "Karya yang dikirimkan tidak mengandung unsur pornografi, SARA, plagiarisme, hoax, atau hal merugikan lainnya",
    ],
  },
  {
    id: 4,
    title: "Journalist Photo Competition",
    image: photo,
    category: "SMA/Sederajat & Mahasiswa",
    tema: "AI dalam Lensa Jurnalistik / AI Dibalik Kehidupan Manusia",
    list: [
      "Lomba bersifat individu dan setiap peserta hanya diperbolehkan mengirim maksimal 2 karya foto",
      "Setiap peserta hanya boleh mengikuti 1 jenis lomba",
      "Karya yang dikirimkan merupakan hasil karya orisinil peserta dan belum pernah dipublikasikan ataupun diperlombakan",
      "Peserta wajib mengisi surat pernyataan keaslian karya dan menyerahkannya saat pengumpulan hasil karya",
      "Karya yang dikirimkan tidak mengandung unsur pornografi, SARA, plagiarisme, hoax, atau hal merugikan lainnya",
    ],
  },
  {
    id: 5,
    title: "Short Video Competition",
    image: video,
    category: "SMA/Sederajat & Mahasiswa",
    tema: "Pengadopsian AI dalam Dunia Pers",
    list: [
      "Lomba bersifat individu dan setiap peserta hanya diperbolehkan mengirim maksimal 1 karya video",
      "Setiap peserta hanya boleh mengikuti 1 jenis lomba",
      "Karya yang dikirimkan merupakan hasil karya orisinil peserta dan belum pernah dipublikasikan ataupun diperlombakan",
      "Peserta wajib mengisi surat pernyataan keaslian karya dan menyerahkannya saat pengumpulan hasil karya",
      "Karya yang dikirimkan tidak mengandung unsur pornografi, SARA, plagiarisme, hoax, atau hal merugikan lainnya",
    ],
  },
];

export default datas;
